import { render, staticRenderFns } from "./import-step5.vue?vue&type=template&id=2d7c3251&scoped=true"
import script from "./import-step5.vue?vue&type=script&lang=js"
export * from "./import-step5.vue?vue&type=script&lang=js"
import style0 from "./import-step5.vue?vue&type=style&index=0&id=2d7c3251&prod&lang=scss"
import style1 from "./import-step5.vue?vue&type=style&index=1&id=2d7c3251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c3251",
  null
  
)

export default component.exports